var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('link',{attrs:{"rel":"icon","href":"../public/iconPage__.ico"}}),_c('knd-error-notify'),_c('knd-success-notify'),_c('div',{staticStyle:{"height":"100%"},attrs:{"id":"app"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }